import axios, { AxiosRequestConfig } from 'axios'

export const getHeaderLocale = (language: string) => {
  switch (language) {
    case 'en':
      return 'en'
    case 'zh-TW':
      return 'zh-TW'
    case 'ja':
    default:
      return 'ja'
  }
}

const axiosConfig: AxiosRequestConfig = {
  timeout: 30000,
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'CLOAK-API-KEY': process.env.CLOAK_API_KEY,
    'Content-Type': 'application/json;charset=utf-8',
    xsrfCookieName: 'CSRF-TOKEN',
    xsrfHeaderName: 'X-CSRF-Token',
    Accept: 'application/json',
    'Accept-Language': 'ja-JP',
  },
  responseType: 'json',
}

export const client = axios.create({
  ...axiosConfig,
  baseURL: process.env.API_URL,
})

export const authClient = axios.create({
  ...axiosConfig,
  baseURL: process.env.AUTH_API_URL,
})

export const spaceClient = axios.create({
  ...axiosConfig,
  baseURL: process.env.SPACE_API_URL,
})

export const bookingClient = axios.create({
  ...axiosConfig,
  baseURL: process.env.BOOKING_API_URL,
})

export const search = axios.create({
  baseURL: process.env.ES_URL,
  timeout: 30000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json;charset=utf-8',
    Accept: 'application/json',
  },
  responseType: 'json',
})

export const ecboClient = axios.create({
  ...axiosConfig,
  baseURL: process.env.ECBO_API_URL,
})
